import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { faArrowsRotate } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Card, Form, Layout, Typography } from "antd";
import axios from "axios";

import {
	apiUrl,
	date,
	description,
	encrypt,
	logo,
	name,
} from "../../../providers/companyInfo";
import { checkNetworkStatus } from "../../../providers/useCapacitorStorage";
import validateRules from "../../../providers/validateRules";
import FloatInputPasswordStrength from "../../../providers/FloatInputPasswordStrength";

export default function PageSetupPassword() {
	const { token } = useParams();

	let navigate = useNavigate();

	const [isLoadingChangePass, setIsLoadingChangePass] = useState(false);
	const [errorMessageLogin, setErrorMessageLogin] = useState({
		type: "",
		message: "",
		action: "",
	});

	useEffect(() => {
		axios
			.get(`${apiUrl("api/check_auth_status")}`, {
				headers: {
					Authorization: "Bearer " + token,
				},
			})
			.then((res) => {
				console.log("success");
			})
			.catch((err) => {
				if (err.response.status === 401) {
					navigate("/login");
				}
			});
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [token]);

	const onFinishLogin = (values) => {
		checkNetworkStatus().then((res) => {
			if (res.connected) {
				let data = {
					...values,
					link_origin: window.location.origin,
				};

				setIsLoadingChangePass(true);

				axios
					.post(`${apiUrl("api/setup_password")}`, data, {
						headers: {
							Authorization: "Bearer " + token,
						},
					})
					.then((res) => {
						let data = res.data;
						if (data.success) {
							localStorage.token = data.token;
							localStorage.userdata = encrypt(JSON.stringify(data.data));

							setErrorMessageLogin({
								type: "success",
								message:
									"Password Successfully Set!, you will be redirected to dashboard page",
								action: "",
							});

							setTimeout(() => {
								window.location.reload();
							}, 1000);
						} else {
							setErrorMessageLogin({
								type: "error",
								message: "This email already verified!",
								action: "",
							});
						}
						setIsLoadingChangePass(false);
					});
			} else {
				setErrorMessageLogin({
					type: "error",
					message: <>Please connect to the internet</>,
					action: (
						<Button
							type="link"
							className="btn-edit p-0"
							icon={<FontAwesomeIcon icon={faArrowsRotate} />}
							onClick={() => window.location.reload()}
						/>
					),
				});
			}
		});
	};

	return (
		<Layout.Content>
			<div />

			<Card>
				<div className="logo-wrapper zoom-in-out-box-1 pt-0">
					<img src={logo} alt={name} />
				</div>

				<Typography.Title
					level={3}
					className="text-center text-sign-in-here mb-20 mt-0"
				>
					Setup Your New Password
				</Typography.Title>

				<Form
					layout="vertical"
					className="login-form"
					onFinish={onFinishLogin}
					autoComplete="off"
				>
					<Form.Item
						name="new_password"
						rules={[validateRules.required, validateRules.password2]}
					>
						<FloatInputPasswordStrength
							label="New Password"
							placeholder="New Password"
						/>
					</Form.Item>

					<Form.Item
						name="new_password_confirm"
						rules={[validateRules.required, validateRules.password_validate]}
					>
						<FloatInputPasswordStrength
							label="Re-enter Your New Password"
							placeholder="Re-enter Your New Password"
							className="float-wrapper-pass"
						/>
					</Form.Item>

					<Button
						type="primary"
						htmlType="submit"
						loading={isLoadingChangePass}
						className="btn-main mt-10 btn-sign-in"
						block
						size="large"
					>
						SUBMIT
					</Button>

					{errorMessageLogin.message && (
						<Alert
							className="mt-10"
							type={errorMessageLogin.type}
							message={errorMessageLogin.message}
							action={errorMessageLogin.action}
						/>
					)}
				</Form>
			</Card>

			<Layout.Footer>
				<Typography.Text>
					{`© ${date.getFullYear()} ${description}. All Rights
                        Reserved.`}
				</Typography.Text>
			</Layout.Footer>
		</Layout.Content>
	);
}
